export const useNewsService = () => {
	const getNewsName = (title: string) => {
		return (
			title
				// Convert to lowercase
				.toLowerCase()
				.replace(/ł/g, 'l')
				.replace(/-+/g, ' ')
				.replace(/\//g, ' ')
				// Replace special characters with their closest ASCII equivalents
				.normalize('NFD')
				.replace(/[\u0300-\u036F]/g, '')
				// Replace non-alphanumeric characters (including special symbols) with a dash
				.replace(/[^a-z0-9\s]/g, '')
				// Replace spaces with dashes
				.replace(/\s+/g, '-')
				// Remove any leading or trailing dashes
				.replace(/^-+|-+$/g, '')
		)
	}

	return {
		getNewsName,
	}
}
